<template>
    <div>
        <!-- DATA TABLE Tender yg sedang berlangsung -->
        <v-container>
            <v-data-table
                class="elevation-1"
                :headers="table.headers"
                :items="table.items"
                :items-per-page="10"
                :single-select="true"
                item-key="id"
            >
                <template v-slot:item.status="{item}">
                    <v-chip v-if="item.status === 'T0'" color="yellow">Non-Tender</v-chip>
                    <v-chip v-else-if="item.status === 'T1'" color="blue">Tender</v-chip>
                    <v-chip v-else color="green">Tender Selesai</v-chip>
                </template>
                <template v-slot:item.tahap="{item}">
                    <v-chip color="grey">{{tenderLib.getTahapTenderAsString(tenderLib.getTahapTenderValue(item))}}</v-chip>
                </template>
                <template v-slot:item.actions="{item}">
                    <v-btn color="blue" small icon @click="openForm(item)"> <v-icon small class="mr-2">mdi-file</v-icon> </v-btn>
                </template>
            </v-data-table>
        </v-container>
        

        <!-- DIALOG -->
        <v-dialog v-model="form.isShowing" max-width="1200" persistent>
            <v-card>
            <v-container>
                <v-tabs dark>
                    <!-- TAB: INFORMASI TENDER -->
                    <v-tab>Informasi Tender</v-tab>
                    <v-tab-item>
                        <v-container>
                            <v-row dense> <v-col> <v-text-field v-model="form.tender.id" label="Kode Tender" readonly /> </v-col> </v-row>
                            <v-row dense> <v-col> <v-text-field v-model="form.tender.nama" label="Nama Tender" readonly /> </v-col> </v-row>
                            <v-row dense> <v-col cols="6"> <v-text-field :value="tenderLib.getTahapTenderAsString(form.tahap)" label="Tahap Tender" readonly /> </v-col> </v-row>
                            <v-row dense> <v-col cols="6"> <v-text-field v-model="form.tender.listPeserta.length" label="Jumlah Peserta" readonly /> </v-col> </v-row>

                            <v-row class="blue-grey" dense> 
                                <v-col> <v-subheader class="title">Berita Acara</v-subheader> </v-col> 
                            </v-row>
                            <v-row v-if="canUploadBeritaAcaraPemberianPenjelasan()">
                                <v-col v-if="form.tender.fileBeritaAcaraPenjelasan === ''" align-self="center" cols="4"> <span class="red--text">* Pemberian penjelasan belum dilampirkan</span> </v-col>
                                <v-col v-else align-self="center" cols="4">
                                    <v-label>Berita Acara Pemberian Penjelasan</v-label>
                                    <v-btn icon color="green" @click.prevent="tenderLib.getFileDownloadLink(form.tender.id, 'BeritaAcaraPenjelasan', form.tender.fileBeritaAcaraPenjelasan, false)"><v-icon>get_app</v-icon></v-btn>
                                </v-col>
                                <v-col cols="4"> <v-file-input v-model="form.uploadFileBeritaAcaraPenjelasan" label="Upload" dense /> </v-col>
                            </v-row>
                            <v-row v-if="canUploadBeritaAcaraPemberianPenjelasan()">
                                <v-col> <v-btn class="teal">Simpan Berita Acara</v-btn> </v-col>
                            </v-row>
                        </v-container>
                    </v-tab-item>


                    <!-- TAB: PERTANYAAN DAN PENJELASAN -->
                    <template>
                        <v-tab>Pertanyaan dan Penjelasan</v-tab>
                        <v-tab-item>
                            <v-container>
                                <v-row>
                                    <v-col> <v-btn color="teal darken-2" dark @click="openChatTopicForm()">Buat Topik</v-btn> </v-col>
                                </v-row>
                                <v-card v-for="(topic, i) in form.tender.listChat" :key="'topic' + i">
                                    <v-container>
                                        <v-row class="blue lighten-1" dense>
                                            <v-col>[{{topic.creator}}] [{{getFormattedDateTimeString(topic.createdAt)}}] </v-col>
                                        </v-row>
                                        <v-row class="blue lighten-1" dense>
                                            <v-col>{{topic.subject}}</v-col>
                                        </v-row> 
                                        <v-row>
                                            <v-col>{{topic.message}}</v-col>
                                        </v-row>
                                    </v-container>
                                </v-card>
                            </v-container>
                        </v-tab-item>
                    </template>


                    <!-- TAB: PENAWARAN -->
                    <template>
                        <v-tab>Penawaran</v-tab>
                        <v-tab-item>
                            <v-container>
                                <v-row v-for="(vendor, i) in form.tender.listPeserta" :key="'peserta' + i">
                                    <v-col cols="1"> <v-text-field v-model="vendor.id" label="Kode" readonly /> </v-col>
                                    <v-col cols="4"> <v-text-field v-model="vendor.nama" label="Nama" readonly /> </v-col>
                                    <v-col v-if="vendor.tender_peserta.fileDokumenPenawaran === ''" align-self="center" cols="4"> <span class="red--text">* Belum ada penawaran</span> </v-col>
                                    <v-col v-else align-self="center" cols="4">
                                        <v-label>Download dokumen penawaran</v-label>
                                        <v-btn icon color="green" @click.prevent="tenderLib.getFileDownloadLink(form.tender.id, 'vendor', vendor.tender_peserta.fileDokumenPenawaran, vendor.id)"><v-icon>get_app</v-icon></v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-tab-item>
                    </template>


                    <!-- TAB: EVALUASI -->
                    <template>
                        <v-tab>Evaluasi</v-tab>
                        <v-tab-item>
                            <v-card v-for="(vendor, i) in form.tender.listPeserta" :key="'peserta' + i">
                                <v-container>
                                    <v-row class="grey" dense>
                                        <v-col> <v-subheader class="title">{{vendor.id}} - {{vendor.nama}}</v-subheader> </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col cols="2"> <v-text-field v-model="vendor.tender_peserta.hargaPenawaran" label="Harga Penawaran" readonly /> </v-col>
                                        <v-col cols="2"> <v-text-field v-model="vendor.tender_peserta.hargaTerkoreksi" label="Harga Terkoreksi" readonly /> </v-col>
                                        <v-col cols="2"> <v-text-field v-model="vendor.tender_peserta.hargaNegosiasi" label="Harga Negosiasi" readonly /> </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col> <v-checkbox v-model="vendor.tender_peserta.evaluasiAdministrasi" label="Administrasi"></v-checkbox> </v-col>
                                        <v-col> <v-checkbox v-model="vendor.tender_peserta.evaluasiKualifikasi" label="Kualifikasi"></v-checkbox> </v-col>
                                        <v-col> <v-checkbox v-model="vendor.tender_peserta.evaluasiTeknis" label="Teknis"></v-checkbox> </v-col>
                                        <v-col> <v-checkbox v-model="vendor.tender_peserta.evaluasiHarga" label="Harga"></v-checkbox> </v-col>
                                        <v-col> <v-checkbox v-model="vendor.tender_peserta.pembuktianKualifikasi" label="Pembuktian"></v-checkbox> </v-col>
                                        <v-col> <v-checkbox v-model="vendor.tender_peserta.pemenang" label="Pemenang"></v-checkbox> </v-col>
                                        <v-col v-if="vendor.tender_peserta.pemenang"> <v-autocomplete v-model="vendor.tender_peserta.urutan" :items="selectionUrutanMenang" label="Urutan Menang" /> </v-col>
                                    </v-row>
                                </v-container>
                                <v-divider></v-divider>
                            </v-card>
                            <v-container>
                                <v-row>
                                    <v-col> <v-btn color="teal darken-2" dark @click="submitEvaluasi()">Simpan Data Evaluasi</v-btn> </v-col>
                                    <v-col class="green" v-if="form.dataEvaluasiSaved"> <p>Data evaluasi telah tersimpan</p> </v-col>
                                </v-row>
                            </v-container>
                        </v-tab-item>
                    </template>
                </v-tabs>

                <!-- ACTIONS -->
                <v-card class="grey">
                    <v-card-actions>
                        <v-btn color="cyan" @click="closeForm()">Tutup</v-btn>
                    </v-card-actions>
                </v-card>
            </v-container>
            </v-card>
        </v-dialog>


        <v-dialog v-model="formChat.isShowing" max-width="800" persistent>
            <v-form ref="formChat" v-model="formChat.isValid" lazy-validation>
                <v-card>
                    <v-container>
                        <v-row>
                            <v-col> <v-text-field v-model="formChat.topic.subject" label="Subject" :rules="[formRules.required]" /> </v-col>
                        </v-row>
                        <v-row>
                            <v-col> <v-textarea v-model="formChat.topic.message" label="Pesan" :rules="[formRules.required]" outlined /> </v-col>
                        </v-row>
                        <v-card class="grey">
                            <v-card-actions>
                                <v-btn color="cyan" @click="closeChatTopicForm()">Batal</v-btn>
                                <v-btn color="green" @click="submitChatTopicForm()">Simpan</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-container>
                </v-card>
            </v-form>
        </v-dialog>

    </div>
</template>



<script>

const API_URL = process.env.VUE_APP_ROOT_API
const axios = require('axios').default;
import { rules as Rules } from "./../../lib/rules";
import { itemsKbli, itemsJenisPengadaan, itemsMetodePemilihan, itemsMetodeKualifikasi, itemsMetodeEvaluasi, itemsJenisKontrak, itemsPemenang, itemsUrutanMenang } from "./../../lib/viewLib";
import { ETahapTender, TenderLib } from "./../../lib/tenderLib";


export default {
    data() {
        return {
            selectionKBLI: itemsKbli,
            selectionJenisPengadaan: itemsJenisPengadaan,
            selectionMetodePemilihan: itemsMetodePemilihan,
            selectionMetodeKualifikasi: itemsMetodeKualifikasi,
            selectionMetodeEvaluasi: itemsMetodeEvaluasi,
            selectionJenisKontrak: itemsJenisKontrak,
            selectionPemenang: itemsPemenang,
            selectionUrutanMenang: itemsUrutanMenang,
            tenderLib: TenderLib,

            // Data table tender
            table:
            {
                headers:
                [
                    { text: "Kode", value: "id" },
                    { text: "Nama", value: "nama" },
                    { text: "Status", value: "status" },
                    { text: "Tahap", value: "tahap" },
                    { text: "Actions", value: "actions" }
                ],
                items: []
            },


            form:
            {
                tender: 
                {
                    id: "",
                    nama: "",
                    listPeserta: [],
                    listChat: []
                },
                tahap: ETahapTender.NONE,
                uploadFileBeritaAcaraPenjelasan: null,
                uploadFileBeritaAcaraEvaluasi: null,
                uploadFileBeritaAcaraNegosiasi: null,
                uploadFileBeritaAcaraPemilihan: null,
                dataEvaluasiSaved: false,
                isShowing: false
            },


            formChat:
            {
                topic: 
                {
                    tahap: "",
                    creator: "",
                    subject: "",
                    message: ""
                },
                isShowing: false,
                isSubmitting: false,
                isValid: false
            },

            formRules:
            {
                required: Rules.required,
            }
        }
    },


    created() {
        axios.get(`${API_URL}/api/tender/proses`)
        .then( (response) => {
            this.table.items = response.data;
        })
        .catch( (error) => {
            console.error(error);
        });
    },


    methods: {
        canUploadBeritaAcaraPemberianPenjelasan() {
            return this.form.tahap > ETahapTender.PEMBERIAN_PENJELASAN;
        },


        getFormattedDateTimeString(dateTime) {
            const date = new Date(dateTime.toString());
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            const hours = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);
            const seconds = ("0" + date.getSeconds()).slice(-2);

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },


        toCurrency(number) {
            let formatter = new Intl.NumberFormat("ID", {
                style: "currency",
                currency: "IDR"
            });

            return formatter.format(number);
        },


        resetForm() {
            this.form.tender = {
                id: "",
                nama: "",
                listPeserta: [],
                listChat: []
            };

            this.form.tahap = ETahapTender.NONE;
            this.form.uploadFileBeritaAcaraPenjelasan = null;
            this.form.uploadFileBeritaAcaraEvaluasi = null;
            this.form.uploadFileBeritaAcaraNegosiasi = null;
            this.form.uploadFileBeritaAcaraPemilihan = null;
            this.form.dataEvaluasiSaved = false;
        },

        
        closeForm() {
            this.form.isShowing = false;
            this.form.dataEvaluasiSaved = false;
        },


        async openForm(tender) {
            if (tender == null) return;

            this.resetForm();
            this.$store.dispatch("displayProgBar");

            await axios.get(`${API_URL}/api/tender/tahap/${tender.id}`)
            .then( (response) => {
                console.log("Response proses tender: ", response.data);
                this.form.tender = response.data;
                this.form.tahap = TenderLib.getTahapTenderValue(tender);
                this.form.isShowing = true;
            })
            .catch( (error) => {
                console.error(error);
            })
            .finally( () => {
                this.$store.dispatch('closeProgBar');
            });
        },


        submitEvaluasi() {
            if (this.form.tender.listPeserta.length == 0) return;

            this.form.tender.listPeserta.forEach(element => {
                const data = {
                    vendorId: element.id,
                    evaluasiAdministrasi: element.tender_peserta.evaluasiAdministrasi,
                    evaluasiKualifikasi: element.tender_peserta.evaluasiKualifikasi,
                    evaluasiTeknis: element.tender_peserta.evaluasiTeknis,
                    evaluasiHarga: element.tender_peserta.evaluasiHarga,
                    pembuktianKualifikasi: element.tender_peserta.pembuktianKualifikasi,
                    pemenang: element.tender_peserta.pemenang,
                    urutan: element.tender_peserta.pemenang ? element.tender_peserta.urutan : 99
                };

                console.log("Save evaluasi: ", data);
                
                axios.put(`${API_URL}/api/tender/evaluasi/${this.form.tender.id}`, data)
                .catch( (error) => {
                    console.error(error);
                });
            });

            this.form.dataEvaluasiSaved = true;
        },


        resetChatTopicForm() {
            this.formChat.topic = {
                tahap: "",
                creator: "",
                subject: "",
                message: ""
            };
        },


        openChatTopicForm() {
            this.resetChatTopicForm();
            this.formChat.isShowing = true;
        },


        closeChatTopicForm() {
            this.formChat.isShowing = false;
        },


        async submitChatTopicForm() {
            if (!this.$refs.formChat.validate())
            {
                this.formChat.isSubmitting = false;
                return;
            }

            const currentTahap = TenderLib.getTahapTender(this.form.tender);

            if (currentTahap === ETahapTender.MASA_SANGGAH_HASIL)
            {
                this.formChat.topic.tahap = "SH";
            }
            else
            {
                this.formChat.topic.tahap = "PP";
            }

            this.formChat.topic.creator = this.$store.getters["userInfo"].nama;
            console.log(`TenderId: ${this.form.tender.id}`, this.formChat.topic);

            await axios.post(`${API_URL}/api/tender/chat/${this.form.tender.id}`, this.formChat.topic)
            .then( (response) => {
                const chat = {
                    id: response.data.id,
                    tahap: response.data.tahap,
                    creator: response.data.creator,
                    subject: response.data.subject,
                    message: response.data.message,
                    createdAt: response.data.createdAt,
                    updatedAt: response.data.updatedAt,
                    fk_tenderId: response.data.fk_tenderId,
                    listMessage: []
                };

                this.form.tender.listChat.push(chat);
            })
            .catch( (error) => {
                console.error(error);
            })
            .finally( () => {
                this.closeChatTopicForm();
            });

        }
    }
}

</script>
